import { render, staticRenderFns } from "./dialogConfirmDeleteMenu.vue?vue&type=template&id=473ecd74&"
import script from "./dialogConfirmDeleteMenu.vue?vue&type=script&lang=js&"
export * from "./dialogConfirmDeleteMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports